// extracted by css-extract-rspack-plugin
export default {"chartWrapper":"iSh2i","gridChart":"_910QA","gridChartLabel":"Z4q_5","chart":"_dbYG"};